webpackJsonp([0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("+prg");
module.exports = __webpack_require__("lVK7");


/***/ }),

/***/ "3MJi":
/***/ (function(module, exports) {

module.exports = AnnotationStudioVendors;

/***/ }),

/***/ "B2y6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("wdOX"))(94);

/***/ }),

/***/ "DuR2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("F6/1"))(72);

/***/ }),

/***/ "F6/1":
/***/ (function(module, exports) {

module.exports = AnnotationStudioCore;

/***/ }),

/***/ "Lyqc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__ = __webpack_require__("jxGG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("nakD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__annotation_studio_plugin_core__ = __webpack_require__("iQNC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__annotation_studio_plugin_viewer__ = __webpack_require__("B2y6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__annotation_studio_plugin_resource_editor__ = __webpack_require__("bUTD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__annotation_studio_plugin_tagging__ = __webpack_require__("qo3b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__annotation_studio_plugin_transcriber__ = __webpack_require__("kL5e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__annotation_studio_plugin_drafts__ = __webpack_require__("V+aj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__annotation_studio_plugin_json_preview__ = __webpack_require__("ceUH");










var behaviours = function behaviours(resolveSharedStore) {
  return {
    'annotation-studio-core': function annotationStudioCore(image, attributes) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__annotation_studio_plugin_core__["default"])(image, attributes).then(function (store) {
        return resolveSharedStore(store);
      });
    },
    'annotation-studio-viewer': __WEBPACK_IMPORTED_MODULE_3__annotation_studio_plugin_viewer__["default"],
    'annotation-studio-resource-editor': __WEBPACK_IMPORTED_MODULE_4__annotation_studio_plugin_resource_editor__["default"],
    'annotation-studio-tagging-annotations': __WEBPACK_IMPORTED_MODULE_5__annotation_studio_plugin_tagging__["TaggingAnnotationsPlugin"],
    'annotation-studio-tagging': __WEBPACK_IMPORTED_MODULE_5__annotation_studio_plugin_tagging__["TaggingPlugin"],
    'annotation-studio-drafts': __WEBPACK_IMPORTED_MODULE_7__annotation_studio_plugin_drafts__["default"],
    'annotation-studio-transcriber': __WEBPACK_IMPORTED_MODULE_6__annotation_studio_plugin_transcriber__["default"],
    'annotation-studio-json-preview': __WEBPACK_IMPORTED_MODULE_8__annotation_studio_plugin_json_preview__["default"]
  };
};

var _utils$deferred = __WEBPACK_IMPORTED_MODULE_2__annotation_studio_plugin_core__["utils"].deferred(),
    resolve = _utils$deferred.resolve,
    whenToRender = _utils$deferred.promise;

function loadPlugin($el, name, config) {
  try {
    var register = behaviours(resolve);
    var behaviour = register[name];
    if (behaviour.length === 3) {
      whenToRender.then(function (store) {
        return behaviour($el, config, store);
      });
    } else {
      behaviour($el, config);
    }
  } catch (e) {
    console.error('Behaviour does not exist: ' + name, e);
  }
}

document.addEventListener('DOMContentLoaded', function () {
  // Small error-prone example of data behaviour factory.
  for (var _iterator = document.querySelectorAll('[data-behaviour]'), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var $el = _ref;

    loadPlugin($el, $el.getAttribute('data-behaviour'), __WEBPACK_IMPORTED_MODULE_2__annotation_studio_plugin_core__["utils"].getAttributes($el));
  }
});

// Set up a global.
(function (g) {
  g.loadAnnotationStudioPlugin = g.loadAnnotationStudioPlugin ? g.loadAnnotationStudioPlugin : loadPlugin;
})(window || global);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "N3bH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logo-nlw.dda14978.svg";

/***/ }),

/***/ "O615":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "digirati-logo-white.bb26f17a.svg";

/***/ }),

/***/ "V+aj":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("wdOX"))(49);

/***/ }),

/***/ "W2+e":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("3MJi"))(12);

/***/ }),

/***/ "bUTD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("wdOX"))(31);

/***/ }),

/***/ "ceUH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("wdOX"))(53);

/***/ }),

/***/ "hvFc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iQNC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("wdOX"))(3);

/***/ }),

/***/ "jxGG":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("wdOX"))(48);

/***/ }),

/***/ "kL5e":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("wdOX"))(92);

/***/ }),

/***/ "lVK7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scss_main_scss__ = __webpack_require__("hvFc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scss_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__scss_main_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logos_digirati_logo_white_svg__ = __webpack_require__("O615");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logos_digirati_logo_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__logos_digirati_logo_white_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logos_logo_nlw_svg__ = __webpack_require__("N3bH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logos_logo_nlw_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__logos_logo_nlw_svg__);




__webpack_require__("Lyqc");

/***/ }),

/***/ "nakD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("wdOX"))(0);

/***/ }),

/***/ "qo3b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("wdOX"))(86);

/***/ }),

/***/ "wdOX":
/***/ (function(module, exports) {

module.exports = AnnotationStudioPlugins;

/***/ })

},[0]);


// WEBPACK FOOTER //
// app.2a7ec489.js